import type { CSSProperties } from 'react'
import compactUrl from '@/assets/brand/netlink-logo-compact.svg'
import compactOnDarkUrl from '@/assets/brand/netlink-logo-compact-dark.svg'
import horizontalUrl from '@/assets/brand/netlink-logo-horizontal.svg'
import horizontalOnDarkUrl from '@/assets/brand/netlink-logo-horizontal-dark.svg'
import stackedUrl from '@/assets/brand/netlink-logo-stacked.svg'
import stackedOnDarkUrl from '@/assets/brand/netlink-logo-stacked-dark.svg'
import markUrl from '@/assets/brand/netlink-mark.svg'

const VARIANTS = {
  compact: { src: compactUrl, srcOnDark: compactOnDarkUrl, ratio: 568.2 / 110.15 },
  horizontal: { src: horizontalUrl, srcOnDark: horizontalOnDarkUrl, ratio: 622.31 / 151.04 },
  stacked: { src: stackedUrl, srcOnDark: stackedOnDarkUrl, ratio: 473 / 534.31 },
  mark: { src: markUrl, srcOnDark: markUrl, ratio: 1 },
} as const

interface NetlinkLogoProps {
  variant: keyof typeof VARIANTS
  height: number
  onDark?: boolean
  decorative?: boolean
  style?: CSSProperties
}

export function NetlinkLogo({ variant, height, onDark = false, decorative = false, style }: NetlinkLogoProps) {
  const logo = VARIANTS[variant]
  return (
    <img
      src={onDark ? logo.srcOnDark : logo.src}
      alt={decorative ? '' : 'Netlink'}
      width={Math.round(height * logo.ratio)}
      height={height}
      draggable={false}
      style={{ display: 'block', flex: 'none', ...style }}
    />
  )
}
